import * as React from 'react';

import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import classNames from 'classnames';
import { Link, useRouteMatch, useLocation } from 'react-router-dom';
import { countries } from 'config/countries';
import { UserTypes } from 'core/auth/constants';
import { calculateNewUrl } from 'core/i18n/locale';
import LanguageSwitcher from '../language-switcher/LanguageSwitcher';
import { getAdminToolbarSettings } from '../frontend-admin-toolbar/utils';
import styles from './Header.module.styl';
import { ICompProps } from './interfaces';

const Header: React.FC<ICompProps> = ({
  user,
  user: { type },
  menu,
  activeMenu,
}) => {
  const [isMenuVisible, setIsMenuVisible] = React.useState(false);
  const {
    url,
    params: { locale },
  } = useRouteMatch<{ locale: string }>();
  const location = useLocation();
  const getLanguages = () => {
    if (isPreview()) {
      return countries.map(item => item.value).join(',');
    }

    const adminToolbarSettings = getAdminToolbarSettings(user);

    return adminToolbarSettings?.languages || user.languages;
  };

  const renderLogo = () => {
    const isHome = /^\/([a-z]{2})?\/?$/.test(url);

    return isHome ? (
      <div className={styles.logo} />
    ) : (
      <Link to={locale ? `/${locale}/` : '/'}>
        <div className={styles.logo} />
      </Link>
    );
  };

  const toggleMenu = () => {
    setIsMenuVisible(!isMenuVisible);
  };

  const isPreview = () => {
    if (
      type !== UserTypes.ADMIN &&
      type !== UserTypes.SUPERADMIN &&
      type !== UserTypes.EDITOR
    ) {
      return false;
    }

    if (!/^(\/\S{2})?\/preview$/.test(location.pathname)) {
      return false;
    }

    return true;
  };

  return (
    <div className={styles.root}>
      {renderLogo()}
      <div className={styles.mobileMenuButtonWrapper}>
        <IconButton onClick={toggleMenu}>
          <MenuIcon />
        </IconButton>
      </div>
      <div
        className={classNames(styles.menu, {
          [styles.visible]: isMenuVisible,
        })}
      >
        {menu.map(item => (
          <Link
            key={item.id}
            className={
              activeMenu && activeMenu.id === item.id
                ? styles.active
                : undefined
            }
            onClick={toggleMenu}
            to={calculateNewUrl(
              locale,
              item.isDefault ? '/' : `/${item.param}`,
            )}
          >
            {locale && item.translation && item.translation[locale]
              ? JSON.parse(item.translation[locale] as any).title
              : item.title}
          </Link>
        ))}
      </div>
      <div className={styles.right}>
        <LanguageSwitcher languages={getLanguages()} />
        <Link type="button" className={styles.logout} to="/logout">
          Logout
        </Link>
      </div>
    </div>
  );
};

export default Header;
